import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useContext, useState } from "react";

import { Skeleton } from "@mui/material";
import AnimatedNumber from "../../../Component/AnimatedNumber/AnimatedNumber";
import BrandIndexBreakups from "../../../Component/BrandIndexHistory/BrandIndexBreakups";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import Modal from "../../../Component/Modal/Modal";
import MUICard from "../../../Component/UI/MUICard/MUICard";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { DiscoveryContext } from "../discovery-context";
import { LLM_OPTIONS } from "../../../utils/constant";
import classes from "./MarketComparisonItem.module.css";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import BrandAuditIndexBreakups from "../../../Component/BrandIndexHistory/BrandAuditIndexBreakups";


export default function MarketItem({
  category,
  brandIndex,
  index,
  market,
  title,
  llm,
  persona,
  getTooltipProps = () => { },
  onRetry = () => { },
  sentimentSources = [],
  reachSources = [],
  selectedInput,
  isReachSourceValidated=false,
  isSentimentSourceValidated=false
}) {
  const [showBrandIndexBreakups, setShowBrandIndexBreakups] = useState(false);
  const llmName = LLM_OPTIONS.find((option) => option.value === title)?.name;

  const discoveryCtx = useContext(DiscoveryContext);

  let animation = discoveryCtx?.state?.showAnimation ?? true;
   const searchParams = new URLSearchParams(window.location.search);
  const isReporting = searchParams.get("isReporting") === "true";

  function LoadingSkeletion() {
    return (
      <>
        <Skeleton
          variant="rectangular"
          style={{
            zIndex: 1,
            flexGrow: 1,
            height: 220,
            flexBasis: "calc(50% - 12.5px)",
            backgroundColor: "rgb(0 0 0 / 11%)",
          }}
        />
      </>
    );
  }

  const renderConditionalTooltip = (getTooltipProps, label, value, sources, llm,isValidated) => {
    const showTooltip = llm?.toLowerCase().includes("search") && isValidated;

    if (value == null) return null;
    const scoreContent = <span className={showTooltip ? classes.sub_score : ""}>{value}</span>;
    return showTooltip  ? (
      <MUIToolTip {...getTooltipProps(undefined, label, sources, value, undefined, llm)}>
        {scoreContent}
      </MUIToolTip>
    ) : (
      scoreContent
    );
  };


  let cardContent = "";
  let loading = true;
  let hasError = false;
  const transactionStatus = discoveryCtx.state.transactionStatus;
  if (category && !hasError && brandIndex?.total) {
    cardContent = (
      <>
        {!category && (
          <div className={classes.add_container}>
            <MUIIconButton size="large">
              <AddCircleOutlineOutlinedIcon
                style={{ fontSize: 40 }}
                fontSize="large"
              />
            </MUIIconButton>
          </div>
        )}
        {brandIndex?.extras && (
          <MUIIconButton
            data-html2canvas-ignore
            onClick={() => setShowBrandIndexBreakups(true)}
            className={classes.settings}
          >
            <InfoOutlinedIcon />
          </MUIIconButton>
        )}
        <div className={classes.header}>
          <div className={classes.title_container}>
            <span className={classes.title}>{llmName}</span>
          </div>
        </div>
        <div className={classes.content}>
          <AnimatedNumber
            className={classes.score}
            start={!animation || isReporting ? brandIndex?.total : 0}
            end={brandIndex?.total || 0}
            duration={!animation  || isReporting ? 0 : 2000}
          />
          <div className={classes.sub_content}>
            {renderConditionalTooltip(getTooltipProps, "Visibility", brandIndex?.rank, reachSources, llm,isReachSourceValidated)}
            <hr className={classes.divider} />
            {renderConditionalTooltip(getTooltipProps, "Sentiment", brandIndex?.favorability, sentimentSources, llm,isSentimentSourceValidated)}
          </div>

        </div>
      </>
    );
  } else if (transactionStatus === "RETRY") {
    hasError = true;
    loading = false;
  } else if (transactionStatus === "RUNNING") {
    hasError = false;
    loading = true;
  }

  if (category && hasError) {
    cardContent = (
      <ErrorView
        title="Error Fetching brand index score"
        message="Request Failed"
      />
    );
  }

  let categoryCard = "";
  if (cardContent) {
    categoryCard = (
      <MUICard
        variant="elevated"
        elevation={0}
        borderRadius={3}
        className={classes.card}
        width={"90%"}
      >
        {cardContent}
      </MUICard>
    );
  }

  return (
    <div
      className={classes.container}
      id="market_comparison"
      style={{
        backgroundColor: categoryCard ? "#eff4f8" : "inherit",
      }}
    >
      <Modal
        width={1200}
        open={showBrandIndexBreakups}
        handleClose={() => setShowBrandIndexBreakups(false)}
      >
        <BrandAuditIndexBreakups
          data={brandIndex?.extras}
          isOpen={showBrandIndexBreakups}
          type={discoveryCtx.type}
          llm={llm}
          category={category}
          market={market}
          persona ={persona}
          selectedInput={selectedInput}
        />
      </Modal>
      {categoryCard}
      {!brandIndex?.total && loading && !hasError && <LoadingSkeletion />}
    </div>
  );
}
